import { supabase } from '../supabaseClient';

async function getGroups(eventId) {
    let query = supabase.from('EventQueue').select('*').eq('eventId', eventId).order('groupPriority')
    const { data, error, } = await query;
    if (data) return data;
    else throw error;
}

async function insertGroup(obj) {
    let query = supabase.from('EventQueue').insert(obj)
    const { data, error } = await query;
    if (data) return data;
    else throw error;
}

async function updateGroup(obj, id) {
    obj.last_updated_at = new Date().getTime()
    let query = supabase.from('EventQueue').update(obj).eq('groupId', id)
    const { data, error } = await query;
    if (data) return data;
    else throw error;
}

async function deleteGroup(grpId) {
    let query = supabase.from('EventQueue').delete().eq('groupId', grpId)
    const { data, error } = await query;
    if (data) return data;
    else throw error;
}

export { getGroups, insertGroup, deleteGroup, updateGroup }